module.exports = {"_id":false,"collection_name":"page","createdDate":false,"name":"Lorem Page","url":"lorem-page","status":"unpublished","type":"page","title":false,"defaultTitle":true,"meta":{"image":false},"defaultMeta":true,"description":"Description here.","defaultDescription":true,"blocks":[],"fonts":[],"forms":[]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/page.json
// module id = M0D5
// module chunks = 0